export class Button
{
	public static EnabledClass = "btn-load";
	public static LoaderClass = "btn__loader";
	public static LoadingClass = "btn-load--loading";

	static EnableLoading = (button: HTMLElement): void =>
	{
		if (button !== null)
		{
			const loadingIndicator = document.createRange().createContextualFragment(`<span class="${this.LoaderClass}"><svg class="svg-inline--fa fa-spin" aria-hidden="true"><use xlink:href="#fa-solid-fa-spinner-third"></use></svg></span>`);
			button.classList.add(this.EnabledClass);
			button.appendChild(loadingIndicator);
		}
	};

	static StartLoading = (button: HTMLElement): void =>
	{
		if (button !== null)
		{
			button.classList.add(this.LoadingClass);
		}
	};

	static StopLoading = (button?: HTMLElement): void =>
	{
		if (typeof button !== "undefined" && button !== null)
		{
			button.classList.remove(this.LoadingClass);
		}
		else
		{
			const buttons = document.querySelectorAll(`.${Button.LoadingClass}`) as NodeListOf<HTMLElement>;

			if (buttons.length > 0)
			{
				buttons.forEach((button) =>
				{
					Button.StopLoading(button);
				});
			}
		}
	};
}